import React from "react";
import image from "assets/hm_service_image/Watch/airpods5.png";
import { SVGs } from "utils/svgs";
import BlankLink from "components/shared/BlankLink";
import { formatPrice } from "utils/helpers";

function Airpods({ prodLink, productname, productPrice, colorText, productId, setProductConfigs, setOpenModal, handleOpenRegistration, conDetail }) {
  return (
    <div className="container airpods-container">
      <div className="content-wrapper">
        <h2 className="title" style={{ fontSize: "40px", color: `${colorText}`, fontWeight: 700 }}>
          <img className="icon-apple" src={colorText === 'black' ? '../hm_service_image/icon_apple2.png' : '../hm_service_image/icon_apple.png'} alt="setting" />
          {productname}
        </h2>

        {/* Chi tiết sản phẩm */}
        <div className="popup-info">
          <img src={SVGs.settting} alt="setting" />
          <a
            className="btn-popup"
            // href="#"
            onClick={() => {
              setProductConfigs(conDetail);
              setOpenModal(true);
            }}
          >
            Chi tiết sản phẩm
          </a>
        </div>


        <div className="text-scroll-watch">Giảm thêm 200K khi mua kèm iPhone 18 series</div>

        <div className="price">
          <label>Chỉ từ:</label>
          <span>{formatPrice(productPrice)}đ</span>
        </div>


        <div style={{ display: 'flex' }}>
          {/* <BlankLink
            className="btn_deposit"
            data-popup-id="popup-registration"
            onClick={() => handleOpenRegistration(productId)}
          >
            Đăng ký nhận tin
          </BlankLink> */}
          
           <BlankLink
            className="btn_deposit"
            data-popup-id="popup-registration"
            onClick={() => window.open(`https://shopdunk.com/tai-nghe-airpods-5`, "_blank")}
          >
            Mua ngay
          </BlankLink>
        </div>
        <div id="image-wrapper-mobile" className="mobile-only-section">
          <img src={image} alt="" width="100%" />
        </div>

        {/* <p className="guest-count airpods-text-follow">
          Theo dõi ShopDunk để nhận thông tin khi sản phẩm sẵn hàng
        </p> */}
      </div>
      <div className="image-wrapper desktop">
        <img src={image} alt="" width="100%" />
      </div>
    </div>
  );
}

export default Airpods;
